import * as React from 'react';

import * as styles from './ProgressBar.css';

interface IProgressBarProps {
  progress: number;
}

export const ProgressBar: React.FC<IProgressBarProps> = ({ progress }) => {
  return (
    <div className={styles['container']}>
      <div
        className={styles['progressbar']}
        role="progressbar"
        aria-valuenow={progress}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div className={styles['progress']} style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
};
